import ThemeChanger from "../Components/ThemeChanger";
import { Mail } from "lucide-react"
import { useState } from "react"
import NavBar from "../Components/NavBar/NavBar";
import Bg from "../Components/background/Bg";
import api from "../api";
import { useToaster } from "../Context/ToasterContext";
import { useNavigate } from "react-router-dom";

export default function Unsubscribe() {
  const [crendentials, setCrendentials] = useState({
    email: "",
    otp: "",
  });
  const navigate = useNavigate();
  const { addToaster, removeToaster } = useToaster()
  const [otpFlag, setOtpFlag] = useState(false)

  const handleGenerateOtp = () => {
    api.post("/auth/unsubscribe-email/generate-otp", {
      email: crendentials.email
    }).then((res) => {
      const response = res.data;
      if (response.statusCode === 200) {
        setOtpFlag(true)
        addToaster("OTP Generated Successfully", 200)
      } else if (response.statusCode === 403) {
        addToaster("User not found", 403)
      } else {
        addToaster("Internal Server Error", 500)
      }
    }).finally(() => {
      setTimeout(() => {
        removeToaster()
      }, 3000)
    })
  }

  const handleOtpVerification = () => {
    api.post("/auth/unsubscribe-email/verify-otp", {
      email: crendentials.email,
      otp: crendentials.otp
    }).then((res) => {
      const response = res.data;
      if (response.statusCode === 200) {
        addToaster("Successfully Unsubscribed", 200)
        navigate("/")
      } else if (response.statusCode === 403) {
        addToaster("User not found", 403)
      } else if (response.statusCode === 404) {
        addToaster("Incorrect Otp", 404)
      }
      else {
        addToaster("Internal Server Error", 500)
      }
    }).finally(() => {
      setTimeout(() => {
        removeToaster()
      }, 3000)
    })
  }
  const handleSubmit = () => {
    removeToaster(); // Clear any existing toaster first
    addToaster("Checking");

    if (!otpFlag) {
      handleGenerateOtp();
    } else {
      handleOtpVerification();
    }
  }
  const handleChange = (e) => {
    setCrendentials({
      ...crendentials,
      [e.target.name]: e.target.value
    });
  }
  return (
    <div className="w-screen h-screen flex justify-center items-center bg-base-100 relative">
      <NavBar page="loginPage" />
      <Bg />
      <div className="w-full max-w-md bg-base-200 rounded-lg shadow-lg p-6 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <div className="flex items-center justify-between mb-6">
          <p className="text-lg font-semibold">Unsubscribe Email</p>
          <ThemeChanger />
        </div>
        <form className="space-y-6" onSubmit={e => { e.preventDefault(); handleSubmit(); }}>
          {otpFlag ? (
            <div>
              <label className="block text-sm font-medium text-base-content mb-2">
                Enter OTP
              </label>
              <div className="relative">
                <input
                  type="number"
                  placeholder="00XXX"
                  className="w-full py-3 pl-4 pr-4 bg-base-100 border border-base-300 rounded-lg focus:ring-2 focus:ring-primary focus:outline-none"
                  required
                  name="otp"
                  value={crendentials.otp}
                  onChange={handleChange}
                  autoComplete="one-time-code"
                />
              </div>
            </div>
          ) : (
            <div>
              <label className="block text-sm font-medium text-base-content mb-2">
                Email Address
              </label>
              <div className="relative">
                <span className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Mail size={18} className="text-base-content/50" />
                </span>
                <input
                  type="email"
                  placeholder="you@example.com"
                  className="w-full py-3 pl-10 pr-4 bg-base-100 border border-base-300 rounded-lg focus:ring-2 focus:ring-primary focus:outline-none"
                  required
                  name="email"
                  value={crendentials.email}
                  onChange={handleChange}
                  autoComplete="email"
                />
              </div>
            </div>
          )}

          <div>
            <button
              type="submit"
              className="w-full bg-primary hover:bg-primary-focus text-primary-content py-3 rounded-lg font-medium transition-colors duration-300"
            >
              {otpFlag ? "Unsubscribe" : "Generate OTP"}
            </button>
          </div>
          {otpFlag && (
            <>
              <p className="text-error text-sm text-center">
                OTP not sent, <span className="text-primary underline underline-offset-2 cursor-pointer" onClick={() => handleGenerateOtp()}>generate again.</span>
              </p>
              <p className="text-error text-sm text-center">
                Wrong Email, <span className="text-primary underline underline-offset-2 cursor-pointer" onClick={() => setOtpFlag(false)}>Start Again.</span>
              </p>
            </>
          )}
        </form>
      </div>
    </div>
  );
}